// 'assets/javascripts/vendor/gsap/minified/gsap.min.js'
// 'assets/javascripts/vendor/gsap/minified/ScrollTrigger.min.js'
// 'assets/javascripts/vendor/vue.min.js'
// 'assets/javascripts/vendor/vuex.js'
// 'assets/javascripts/vendor/vue-clickaway.cs.js'
// 'assets/javascripts/vendor/vuelayers.js'
// 'assets/javascripts/vendor/sweetalert.js'
// 'assets/javascripts/vendor/bxslider.js'
// 'assets/javascripts/vendor/feed.js'
// 'assets/javascripts/vendor/owl.carousel.js'
// 'assets/javascripts/vendor/imagesloaded.pkgd.min.js'
// 'assets/javascripts/vendor/jquery.fancybox.min.js'
// 'assets/javascripts/vendor/colorify.cs.js'
// 'assets/javascripts/vendor/cta.js'
// 'assets/javascripts/vendor/moment.min.js'
// 'assets/javascripts/vendor/locales/moment/fr.js'
// 'assets/javascripts/vendor/nouislider.min.js'
// 'assets/javascripts/vendor/pikaday.js'

// import './apidae/index.js'
// import './elements/index.js'
// import './forms/index.js'
// import './sections/index.js'
// import './components/index.js'
// import './views/index.js'
// import './helpers.js' 

/////////////////////////////////////////////
//////////////Tarteaucitron/////////////////
///////////////////////////////////////////
tarteaucitron.init({
    "privacyUrl": "https://www.golfe-saint-tropez-information.com/fr/mentions-legales-credits", /* Privacy policy url */
  
    "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
    "cookieName": "tarteaucitron", /* Cookie name */
  
    "orientation": "bottom", /* Banner position (top - bottom - middle - popup) */
  
    "groupServices": false, /* Group services by category */
  
    "showAlertSmall": false, /* Show the small banner on bottom right */
    "cookieslist": false, /* Show the cookie list */
    
    "showIcon": false, /* Show cookie icon to manage cookies */
    // "iconSrc": "", /* Optionnal: URL or base64 encoded image */
    "iconPosition": "BottomRight", /* Position of the icon between BottomRight, BottomLeft, TopRight and TopLeft */
  
    "adblocker": false, /* Show a Warning if an adblocker is detected */
  
    "DenyAllCta" : false, /* Show the deny all button */
    "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
    "highPrivacy": true, /* HIGHLY RECOMMANDED Disable auto consent */
  
    "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */
  
    "removeCredit": true, /* Remove credit link */
    "moreInfoLink": true, /* Show more info link */
    "useExternalCss": true, /* If false, the tarteaucitron.css file will be loaded */
    "useExternalJs": false, /* If false, the tarteaucitron.js file will be loaded */
  
    //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for subdomain website */
  
    "readmoreLink": "", /* Change the default readmore link pointing to tarteaucitron.io */
    
    "mandatory": true /* Show a message about mandatory cookies */
  });
  

/////////////////////////////////////////////
/////////////General////////////////////
///////////////////////////////////////////

/*
 * Foundation
 */
$(document).foundation();

moment.locale(lang_url);

/*
 * Menu hover
 */
// $('.SiteHeader .TitleBar-left .menu-icon').mouseenter(function() {
//     $('#offCanvasLeft').foundation('open');
// });
//
// $('#offCanvasLeft').mouseleave(function() {
//     setTimeout(function(){
//         $('#offCanvasLeft').foundation('close');
//     },500);
// });
/*
 * Menu 1st level
 */
jQuery(function($) {
    $(".WideMenu > ul > li.is-dropdown-submenu-parent > a").attr('href', "javascript:void(0)");
});


/*
 * Laravel csrf token
 * http://stackoverflow.com/questions/21627170/laravel-tokenmismatchexception-in-ajax-request
 */
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

/*
 * Colorify
 */
// colorify({
//     id: 1,
//     container: 'colorify',
//     images: false,
//     accuracy: 100,
//     gradient: false,
//     gradientDirection: false,
//     padding: 4,
//     lazyReveal: false,
//     give: false,
//     revealOn: false
// });



/*
 * Date Picker
 */
var pickerDefault = new Pikaday({
    field: document.getElementById('datepicker'),
    format: 'D MMM YYYY',
});
var pickeraArrivalDate = new Pikaday({
    field: document.getElementById('arrivaldate'),
    format: 'D MMM YYYY',
});
var pickerDepartureDate = new Pikaday({
    field: document.getElementById('departuredate'),
    format: 'D MMM YYYY',
});


/*
 ** Read More
 */
$(document).ready(function() {

    $('body').on('click', '.readMore', function(e) {
        e.preventDefault();
        if ($(".readContent").hasClass('readHide')) {
            $(".readContent").animate({ height: '100%' }, 1000).removeClass('readHide');
        } else {
            $(".readContent").animate({ height: '30vh' }, 1000).addClass('readHide');
        }
        $(this).toggleClass("highlight");
        $(this).find('.fa-angle-down, .fa-angle-up').toggle();
    });

    $(".readContent").mouseup(function() {
        return false;
    });

});


/////////////////////////////////////////////
/////////////Scroll Magic////////////////////
///////////////////////////////////////////

// $(function() {

//     //Init ScrollMagic Controller
//     var scrollMagicController = new ScrollMagic.Controller();

//     if ($('.main-slider').length) {
//         var tween_2 = new TimelineMax();

//         tween_2
//             .to($('.main-slider'), 1.4, {
//                 transform: "translate(0,600px)",
//                 ease: Linear.easeNone
//             }, '-=0.2');

//         var scene_2 = new ScrollMagic.Scene({
//                 triggerElement: ".main-slider",
//                 triggerHook: 0,
//                 duration: "300%"
//             })
//             .setTween(tween_2)
//             .addTo(scrollMagicController);
//     }

//     if ($('.HeroReservation').length) {
//         var tween_3 = new TimelineMax();

//         tween_3
//             .to($('.HeroReservation'), 1, { backgroundPosition: "0 100%", ease: Linear.easeNone });

//         var scene_3 = new ScrollMagic.Scene({
//                 triggerElement: ".HeroReservation",
//                 duration: 2000
//             })
//             .setTween(tween_3)
//             .addTo(scrollMagicController);
//     }

//     $('.fluent').each(function() {
//         var currentFluent = this;
//         var tween_fluent = new TimelineMax();

//         tween_fluent
//             .to(currentFluent, 1, { opacity: 0, ease: Linear.easeNone });

//         new ScrollMagic.Scene({
//                 triggerElement: currentFluent,
//                 duration: "65%"
//             })
//             .setTween(tween_fluent)
//             .addTo(scrollMagicController);
//     });

//     if ($('.quickFinder').length) {

//         var tween_ads = new TimelineMax();

//         tween_ads
//             .to($('.quickFinder'), 1, {
//                 transform: "translate(-360px,0)",
//                 ease: Linear.easeNone,
//                 onComplete: function() {
//                     $('.quickFinder').addClass('closed');
//                 }
//             });

//         var scene_ads = new ScrollMagic.Scene({
//                 //triggerElement: ".top-bar",
//                 //triggerHook: "onLeave",
//                 duration: "30%"
//             })
//             .setTween(tween_ads)
//             .addTo(scrollMagicController);
//     }

//     if ($('.scrollToTop').length) {
//         var tween_6 = new TimelineMax();

//         tween_6
//             .from($('.scrollToTop'), 1, { transform: "translate(0,80px)", ease: Power3.easeOut });

//         var scene_6 = new ScrollMagic.Scene({
//                 triggerElement: ".BodyLayout",
//                 triggerHook: "onLeave",
//                 duration: 0
//             })
//             .setTween(tween_6)
//             .addTo(scrollMagicController);
//     }

// });
/////////////////////////////////////////////
/////////////Hero Ads show/hide/////////////
///////////////////////////////////////////
$(document).ready(function() {
    $('.quickFinder .outer').click(function() {
        var self = $('.quickFinder');
        self.toggleClass('closed');
        if (!self.hasClass('closed')) {
            self.addClass('opened');
            scene_ads.update();
        }
    });

});

/////////////////////////////////////////////
/////////Smooth scroll inertia//////////////
///////////////////////////////////////////
// var smoothScroll = {
//     speed: 0,
//     delay: 10, // en ms
//     timer: null,
//     scrollSpeed: 10,
//     inertia: 0.95,
//     init: function(){
//         this.setEventsListeners();
//     },
//     setEventsListeners: function(){
//         var me = this;
//         $(document).bind('DOMMouseScroll mousewheel', function(e){
//             me.setSpeed(e.originalEvent);
//         });
//     },
//     setSpeed: function(e){
//         var direction = e.detail ? -e.detail : e.wheelDelta;
//         this.speed += direction < 0 ? -this.scrollSpeed : this.scrollSpeed;
//         if(this.timer == null){
//             this.timer = setTimeout(this.smoothScroll, this.delay, this);
//         }
//         e.preventDefault();
//     },
//     smoothScroll: function(scope){
//         var self = scope;
//         self.speed *= self.inertia;
//
//         var currScrollTop = $(window).scrollTop();
//         $(window).scrollTop(currScrollTop-self.speed);
//
//         if(self.speed < self.inertia && self.speed > -self.inertia){
//             self.speed = 0;
//             clearTimeout(self.timer);
//             self.timer = null;
//         }else{
//             self.timer = setTimeout(self.smoothScroll, self.delay, self);
//         }
//     }
// };
//
// smoothScroll.init();


/////////////////////////////////////////////
//////// Track Google Analytics Events /////
///////////////////////////////////////////
// document.querySelectorAll('.gtag').forEach(function(gtagElement) {
//     gtagElement.addEventListener("click", function(e) {
//         e.preventDefault();
//         //console.log(this);

//         var action = this.dataset.action;
//         var category = this.dataset.category;
//         var label = this.dataset.label;
//         var value = this.dataset.value;
//         var href = this.getAttribute('href');

//         gtag('event', action, {
//             'event_category': category,
//             'event_label': label,
//             'value': value,
//             'event_callback': function() {
//                 window.location = href;
//             }
//         });
//     })
// })


/**
 * Carousel
 */
 if (document.querySelector('#carousels')) {
    new Vue({
            store,
            el: document.querySelector('#carousels'),
            components: { 'carousels': carousels }
        })
        // document.querySelectorAll('.carousels').forEach(c => {
        //   let id = c.getAttribute('id');
        //   new Vue({
        //       store,
        //       el: document.querySelector('#' + id),
        //       components: { 'carousel': carousel }
        //   })
        // })
    // new Vue({
    //     store,
    //     render: h => h(carousel),
    //   }).$mount('#carousel')
  }